import AvatarM from "@common/components/avatar/AvatarM"
import { BadgeM } from "@common/components/badge/BadgeM"
import TouchableRippleM from "@common/components/button/TouchableRippleM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { DimensionsContext } from "@common/utils/mobileUtils"
import { apiIdle, apiRequest } from "@data/redux/actions/api"
import { setIsLiveModeEnabled } from "@data/redux/actions/liveMode"
import { authService } from "@data/services/authService"
import { hasRole } from "@data/utility/ability"
import { AbilityContext } from "@data/utility/Can"
import { isSubscribed, isSubscriptionPaused } from "@data/utility/dataUtils"
import { formatDate } from "@data/utility/Utils"
import { useFocusEffect } from "@react-navigation/native"
import { StatusBar } from "@common/systemBars/StatusBar"
import moment from "moment"
import React, { useCallback, useContext, useRef } from "react"
import { RefreshControl, ScrollView, StyleSheet, View } from "react-native"
import FontAwesome5 from "react-native-vector-icons/FontAwesome5"
import { connect } from "react-redux"
import BecomePremiumCard, {
    canSubscribeToEssential,
    canSubscribeToTrialEssential,
} from "../account/subscription/BecomePremiumCard"
import ChampionBubble from "../champions/ChampionBubble"
import StudentLiveSessionsList from "./StudentLiveSessionsList"

const styles = StyleSheet.create({
    container: {
        flex: 1,
        alignItems: "center",
        justifyContent: "flex-start",
        paddingTop: 10,
        alignSelf: "center",
    },
})

export const ListButtonM = (props) => {
    const {
        onPress,
        icon,
        title,
        description,
        subTitle,
        badgeCount,
        disabled,
        isLast = false,
        style,
        tinyMode = false,
    } = props

    return (
        <TouchableRippleM
            onPress={onPress}
            underlayColor={theme.colors.lightMore}
            disabled={disabled}
            style={{
                borderBottomWidth: isLast ? 0 : 1,
                paddingHorizontal: 15,
                paddingVertical: 15,
                alignItems: "center",
                borderColor: theme.colors.lightMore,
                height: tinyMode ? 50 : 84,
                flexDirection: "row",
                width: "100%",
                ...style,
            }}
        >
            <>
                <View>
                    {icon}
                    {badgeCount > 0 && (
                        <BadgeM
                            count={badgeCount}
                            style={{
                                backgroundColor: theme.colors.error,
                                color: theme.colors.white,
                                position: "absolute",
                                top: -5,
                                right: -5,
                            }}
                        />
                    )}
                </View>
                <View style={{ marginLeft: 15, flex: 1 }}>
                    <TextM
                        fontWeight={"Bold"}
                        color={theme.colors.primary}
                        wrap
                        fontSize={18}
                    >
                        {title}
                    </TextM>
                    {subTitle && (
                        <TextM
                            fontWeight={"SemiBold"}
                            color={theme.colors.primary}
                            wrap
                            fontSize={16}
                        >
                            {subTitle}
                        </TextM>
                    )}
                    {description && (
                        <TextM
                            fontWeight={"Medium"}
                            color={theme.colors.light}
                            wrap
                            fontSize={14}
                        >
                            {description}
                        </TextM>
                    )}
                </View>
                {!disabled && (
                    <FontAwesome5
                        name={"chevron-right"}
                        solid
                        size={24}
                        color={theme.colors.primary}
                    />
                )}
            </>
        </TouchableRippleM>
    )
}

// const AttendanceFlagsCard = ({student}) => {
//     const dimensions = useContext(DimensionsContext)
//
//     const navigation = useNavigation()
//     const attendanceCounts = student?.live_sessions?.reduce((counts, session) => {
//         session?.attendance_flags?.forEach(flag => {
//             if (flag.type === "late" && student?.id === flag?.user_id) {
//                 counts.late += 1;
//             } else if (flag.type === "absent" && student?.id === flag?.user_id) {
//                 counts.absence += 1;
//             }
//         });
//         return counts;
//     }, {late: 0, absence: 0});
//
//     return <View style={{
//         flexDirection: dimensions.width > 800 ? 'row' : 'column',
//         alignItems: "center",
//         gap: 20,
//         marginTop: 5
//     }}>
//         <LinkTextM
//             mode={"text"}
//             style={{
//                 fontSize: 15
//             }}
//             onPress={() => {
//                 navigation.push("absence-form", {
//                     id: student.id
//                 })
//             }}
//         >
//             {"SIGNALER RETARD OU ABSENCE"}
//         </LinkTextM>
//         {attendanceCounts?.absence > 0 && <LinkTextM
//             mode={"text"}
//             style={{
//                 fontSize: 15,
//                 color: theme.colors.error
//             }}
//             onPress={() => {
//                 navigation.push("cancel-absence", {
//                     id: student.id,
//                     type: "absence"
//                 })
//             }}
//         >
//             {"Absences signalées : " + attendanceCounts?.absence}
//         </LinkTextM>}
//         {attendanceCounts?.late > 0 && <LinkTextM
//             mode={"text"}
//             style={{
//                 fontSize: 15,
//                 color: theme.colors.warning
//             }}
//             onPress={() => {
//                 navigation.push("cancel-absence", {
//                     id: student.id,
//                     type: "late"
//                 })
//             }}
//         >
//             {"Retards signalés : " + attendanceCounts?.late}
//         </LinkTextM>}
//     </View>;
// }

const MyCoachTabScreen = (props) => {
    const dimensions = useContext(DimensionsContext)

    const { navigation, route } = props
    const ability = useContext(AbilityContext)

    const scrollToEnd =
        route.params?.scroll_to_end || route.params?.scroll_to_end === "true"

    const scrollViewRef = useRef()

    useFocusEffect(
        useCallback(() => {
            if (scrollToEnd) {
                scrollViewRef.current?.scrollToEnd({ animated: true })
                setTimeout(() => {
                    navigation?.setParams({
                        ...route?.params,
                        scroll_to_end: null,
                    })
                }, 500)
            }
        }, [scrollToEnd])
    )

    const initialCondition =
        hasRole(props.user, "student") &&
        !isSubscribed(props.user) &&
        ability.cannot("read", "holiday_course_views")

    const currentStudentTutors =
        props.user?.live_sessions
            ?.map((ls) => ls?.tutor)
            ?.filter((tutor) => tutor?.id !== props.user?.tutor?.id)
            ?.filter(
                (tutor, index, self) =>
                    index === self.findIndex((t) => t?.id === tutor?.id)
            ) ?? []

    const allTutors = [props?.user?.tutor, ...currentStudentTutors].filter(
        (tutor) => tutor?.id
    )

    return (
        <View
            style={{
                backgroundColor: theme.colors.whiteAlmost,
                alignItems: "center",
                flex: 1,
            }}
        >
            <ScrollView
                refreshControl={
                    <RefreshControl
                        refreshing={!!props.getUserRequest}
                        onRefresh={() => props.apiRequest(authService.getUser)}
                        containerStyle={[
                            styles.container,
                            { width: dimensions?.width },
                        ]}
                    />
                }
                ref={scrollViewRef}
            >
                <View
                    style={{
                        alignItems: "center",
                    }}
                >
                    <View style={{ width: dimensions?.width }}>
                        {!props.user?.tutor &&
                            (ability.can("read", "have_tutor") ? (
                                <>
                                    <FontAwesome5
                                        name="hourglass-half"
                                        style={{
                                            marginTop: 30,
                                            marginBottom: 10,
                                        }}
                                        size={40}
                                        color={theme.colors.grey}
                                    />
                                    <TextM
                                        color={theme.colors.grey}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                            paddingHorizontal: 20,
                                        }}
                                        fontWeight="Medium"
                                        wrap
                                    >
                                        Tu recevras une notification dès que
                                        nous t'aurons attribué un groupe de Live
                                        et un tuteur.
                                    </TextM>
                                </>
                            ) : !isSubscriptionPaused(props.user) ? (
                                <View style={{ flex: 1 }}>
                                    <TextM
                                        color={theme.colors.grey}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                            paddingHorizontal: 20,
                                        }}
                                        fontWeight="Medium"
                                        wrap
                                    >
                                        Tu n'as pas d'abonnement actif.
                                    </TextM>
                                    <TextM
                                        color={theme.colors.grey}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                            paddingHorizontal: 20,
                                        }}
                                        fontWeight="Medium"
                                        wrap
                                    >
                                        Pour avoir un tuteur et participer aux
                                        Lives Masteur, il faut être abonné à
                                        l'une de nos offres.
                                    </TextM>
                                </View>
                            ) : (
                                <View style={{ flex: 1 }}>
                                    <TextM
                                        color={theme.colors.grey}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                            paddingHorizontal: 20,
                                        }}
                                        fontWeight="Medium"
                                        wrap
                                    >
                                        Ton abonnement est en pause.
                                    </TextM>
                                    <TextM
                                        color={theme.colors.grey}
                                        style={{
                                            textAlign: "center",
                                            marginTop: 10,
                                            paddingHorizontal: 20,
                                        }}
                                        fontWeight="Medium"
                                        wrap
                                    >
                                        Tu pourras accéder à ce menu lors de la
                                        reprise de ton abonnement, le{" "}
                                        {formatDate(
                                            moment(
                                                props.user?.subscription_state
                                                    ?.planned_start_date
                                            )
                                        )}
                                    </TextM>
                                </View>
                            ))}
                    </View>

                    <BecomePremiumCard
                        style={{
                            marginTop: 20,
                            marginBottom: 20,
                        }}
                    />

                    {initialCondition &&
                        (canSubscribeToTrialEssential(props.user) ||
                            canSubscribeToEssential(props.user)) &&
                        !isSubscriptionPaused(props.user) && (
                            <ChampionBubble
                                name={"tina"}
                                variant={"main"}
                                championPosition="left"
                                style={{
                                    marginTop: 10,
                                }}
                                texts={[
                                    "C'est grâce à l'aide de mon masteur que je suis devenue une championne !",
                                ]}
                                onNextPress={() => {}}
                            />
                        )}

                    {allTutors.length > 0 && (
                        <View
                            style={{
                                width: dimensions?.width,
                                alignItems: "center",
                            }}
                        >
                            <View
                                style={{
                                    marginTop: 30,
                                    marginBottom: 10,
                                    width: dimensions?.width,
                                    alignItems: "center",
                                }}
                            >
                                <TextM
                                    style={{
                                        textAlign: "flex-start",
                                        marginTop: 0,
                                        alignSelf: "flex-start",
                                        marginLeft: 25,
                                    }}
                                    fontWeight="Bold"
                                    color={theme.colors.primary}
                                    fontSize={20}
                                >
                                    {allTutors.length === 1
                                        ? "Mon Masteur"
                                        : "Mes Masteurs"}
                                </TextM>

                                {allTutors.map((tutor, index) => {
                                    const isMainTutor =
                                        tutor?.id === props.user?.tutor?.id

                                    const badgeCount = isMainTutor
                                        ? props?.user
                                              ?.tutor_messenger_not_read_count
                                        : props.user?.live_sessions
                                              ?.filter(
                                                  (ls, index, self) =>
                                                      index ===
                                                      self.findIndex(
                                                          (t) =>
                                                              t.tutor?.id ===
                                                              ls.tutor?.id
                                                      )
                                              )
                                              ?.map(
                                                  (ls) =>
                                                      ls
                                                          ?.unread_private_messages_count?.[
                                                          ls?.tutor?.id
                                                      ]
                                              )
                                              ?.reduce(
                                                  (acc, count) => acc + count,
                                                  0
                                              )

                                    return (
                                        <ListButtonM
                                            key={index}
                                            icon={
                                                <AvatarM
                                                    user={tutor}
                                                    size={30}
                                                />
                                            }
                                            badgeCount={badgeCount}
                                            title={tutor?.display_name}
                                            description={"Messages"}
                                            style={{
                                                backgroundColor:
                                                    theme.colors.white,
                                                width: dimensions?.width - 40,
                                                borderRadius: theme.roundness,
                                                borderWidth: 1,
                                                borderColor:
                                                    theme.colors.lightMore,
                                                marginTop: 10,
                                            }}
                                            onPress={() => {
                                                if (isMainTutor) {
                                                    navigation.push(
                                                        "messenger",
                                                        {}
                                                    )
                                                } else {
                                                    navigation.push(
                                                        "messenger",
                                                        {
                                                            tutorId: tutor?.id,
                                                        }
                                                    )
                                                }
                                            }}
                                        />
                                    )
                                })}
                            </View>

                            <StudentLiveSessionsList
                                style={{
                                    marginTop: 30,
                                    width: dimensions?.width,
                                    paddingHorizontal: 20,
                                }}
                                withFillerView
                            />
                        </View>
                    )}
                </View>
            </ScrollView>
            <StatusBar
                style="dark"
                backgroundColor={theme.colors.white}
                translucent={false}
            />
        </View>
    )
}
const mapStateToProps = (state) => {
    return {
        getUserRequest: state.api.getUser?.request,
        getUserSuccess: state.api.getUser?.success,
        getUserError: state.api.getUser?.error,
        activityTemplates: state.data.staticData?.activity_templates,
        user: state.data.currentUser?.object,
        maxPrioritizedSchoolSubjects:
            state.data.staticData?.max_prioritized_school_subjects,
        isLive: state.liveMode.isLiveModeEnabled,
        getLiveSessionRequest: state.api.getLiveSession?.request,
    }
}

const mapDispatchToProps = {
    apiRequest,
    apiIdle,
    setIsLiveModeEnabled,
}

export default connect(mapStateToProps, mapDispatchToProps)(MyCoachTabScreen)
